export default "__VITE_ASSET__1faf9ab4__"